const timesheetSystemServiceServiceName = "/TimesheetManagement";

export function timesheetManagementSystem(http) {
    return {
        getPersonnelTimesheetData: userId => {
            var param = {
                "UserId": userId,
            }
            return http.post(timesheetSystemServiceServiceName + "/IsTimesheetAuthorizedUsers", param);
        },
        getUnlockTimesheetDate: () => {
            return http.get(timesheetSystemServiceServiceName + "/GetUnlockTimesheetDate");
        },
        unlockTimesheet: (startDate, endDate) => {
            var param = {
                "StartDate": startDate,
                "EndDate": endDate,
                "Result": false
            }
            return http.post(timesheetSystemServiceServiceName + "/UnlockTimesheet", param);
        },
        saveUnlockTimesheetDates: (startDate, endDate) => {
            var param = {
                "StartDate": startDate,
                "EndDate": endDate
            }
            return http.post(timesheetSystemServiceServiceName + "/SaveUnlockTimesheetDates", param);
        },
        isTimesheetSettingAuthorizedUsers: userProfileId => {
            var param = {
                "UserId": userProfileId
            }
            return http.post(timesheetSystemServiceServiceName + "/IsTimesheetSettingAuthorizedUsers", param);
        }
    }
    
}